<style lang="scss" scoped>
.overview-container {
  width: 702px;
  margin: 24px auto 0;
  .title {
    font-size: 28px;
    line-height: 40px;
    color: #1d1d1d;
    margin-bottom: 22px;
    font-weight: bold;
  }
  .detail-container {
    // border: 1px solid #eeeeee;
    border-bottom: none;
    .detail-item {
      display: flex;
      align-items: center;
      height: 72px;
      margin-bottom: 4px;
      // border-bottom: 1px solid #eeeeee;
      &.desp {
        height: 200px;
      }
      .label {
        width: 176px;
        text-align: center;
        font-size: 28px;
        line-height: 40px;
        color: #1d1d1d;
        font-weight: bold;
        margin-right: 4px;
        height: 72px;
        background-color: #F3F5F6;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        &.desp {
          height: 200px;
        }
      }
      .msg {
        flex: 1;
        // width: 
        padding-left: 32px;
        color: #1d1d1d;
        font-size: 28px;
        background-color: #F8F8F8;
        line-height: 40px;
        // height: 72px;
        display: flex;
        height: 100%;
        // justify-content: center;
        align-items: center;
        padding: 10px 32px;
        &.brand {
          text-decoration: underline;
        }
        .right-icon {
          height: 22px;
          width: 18px;
          margin-left: 8px;
          // margin-top: -4px;
        }
        &.desp {
          // height: 200px;
          align-items: flex-start;
          overflow-y: scroll;
        }
      }
    }
  }
}
</style>

<template>
  <div class="overview-container">
    <div class="title">{{title}}</div>
    <div class="detail-container">
      <div v-if="overViewObj.skc" class="detail-item">
        <div class="label">商品SKC</div>
        <div class="msg">{{overViewObj.skc}}
        </div>
      </div>
      <div v-if="overViewObj.brandEnName" class="detail-item" @click="goBrandPavilion">
        <div class="label">品牌</div>
        <div class="msg brand">{{overViewObj.brandEnName}}
          <img class="right-icon" src="./../../../assets/images/ai-picture/arrow-right.png">
        </div>
      </div>
      <div v-if="overViewObj.seriesName" class="detail-item">
        <div class="label">系列</div>
        <div class="msg">{{overViewObj.seriesName}}</div>
      </div>
      <div v-if="overViewObj.colorName" class="detail-item">
        <div class="label">颜色</div>
        <div class="msg">{{overViewObj.colorName}}</div> 
      </div>
      <div v-if="overViewObj.measurement" class="detail-item">
        <div class="label">尺寸
        </div>
        <div class="msg">{{overViewObj.measurement}}</div>
      </div>
      <div v-if="overViewObj.productCode" class="detail-item">
        <div class="label">货号</div>
        <div class="msg">{{overViewObj.productCode}}</div>
      </div>
      <div v-if="overViewObj.releaseDate" class="detail-item">
        <div class="label">发售日期</div>
        <div class="msg">{{overViewObj.releaseDate}}</div>
      </div>
      <div v-if="overViewObj.releasePrice" class="detail-item">
        <div class="label">发售价格</div>
        <div class="msg">￥{{overViewObj.releasePrice / 100}}</div>
      </div>
      <div v-if="overViewObj.origin" class="detail-item">
        <div class="label">产地</div>
        <div class="msg">{{overViewObj.origin}}</div>
      </div>
      <div v-if="overViewObj.materialStr" class="detail-item">
        <div class="label">材质</div>
        <div class="msg">{{overViewObj.materialStr}}</div>
      </div>
      <div v-if="overViewObj.forPeople" class="detail-item">
        <div class="label">适用人群</div>
        <div class="msg">{{overViewObj.forPeople}}</div>
      </div>
      <div v-if="overViewObj.description" class="detail-item desp">
        <div class="label desp">商品介绍</div>
        <div class="msg desp">{{overViewObj.description}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { H5PAGES_TARO_CONFIG } from './../../../common/navigate-config.js'

export default {
  props: {
    overViewObj: {
      default: () => {
        return {}
      } 
    }, 
    title: {
      default: () => {
        return '概述'
      }
    }
  },
  data () {
    return {}
  },
  methods: {
    goBrandPavilion () {
      if (window.isWXWebView) {
        // alert('enter')
        wx.miniProgram.navigateTo({ url: `/subPackages/choice/brand-pavilion/index?kindID=${this.overViewObj.kindId}&brandID=${this.overViewObj.brandId}` });
      } else {
        H5PAGES_TARO_CONFIG.toBrandPavilion(this.overViewObj.kindId, this.overViewObj.brandId)
      }
    }
  },
  mounted () {
  }
}
</script>
